import { TransferRuleDto } from "@closerplatform/spinner-openapi";
import { FieldState, FormState } from "formstate";
import { TagGroupTransferRuleFields, TagGroupTransferRuleForm } from "./types";
import { validateTagGroup, validateTargetTagGroups } from "./validators";

export const createEmptyRule = () => {
    return mapRuleToForm({
        tagGroupId: "",
        targetTagGroupIds: [],
    });
};

export const copyTagRuleForm = (form: TagGroupTransferRuleForm): TagGroupTransferRuleForm => {
    return mapRuleToForm(mapFormToRule(form));
};

export const mapRuleToForm = (rule: TransferRuleDto): TagGroupTransferRuleForm => {
    return new FormState<TagGroupTransferRuleFields>({
        tagGroupId: new FieldState(rule.tagGroupId).validators(validateTagGroup),
        targetTagGroupIds: new FieldState(rule.targetTagGroupIds).validators(validateTargetTagGroups),
    });
};

export const mapFormToRule = (rule: TagGroupTransferRuleForm): TransferRuleDto => {
    return {
        tagGroupId: rule.$.tagGroupId.$,
        targetTagGroupIds: rule.$.targetTagGroupIds.$,
    };
};
